module.exports = __webpack_public_path__ + "media/icons/thief-circle-36-93158ffe.png";